<template>
  <div class="NavBarMenu pt-4">
    <p class="d-flex align-items-center justify-content-between px-4">
      <strong> Menu </strong>
      <span
        class="NavBarMenu__logout d-inline-flex"
        @click="logout"
      >
        <span>{{ $t("logout") }}</span>
        <i class="fas fa-sign-out-alt ml-2" />
      </span>
    </p>

    <router-link
      v-if="superuser"
      :to="{
        name: 'Dashboard',
        params: { municipality: activeMunicipalitySlug },
      }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-gear mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.adminPanel") }}
      </span>
    </router-link>

    <router-link
      v-if="isPrognoseEnabled || canPreAccessPrognose"
      :to="{ name: 'Viewer', params: { municipality: activeMunicipalitySlug } }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-map mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.chargingstations.forecast") }}
        {{ isPlanmodeEnabled ? "& planning" : "" }}
      </span>
    </router-link>

    <router-link
      v-if="isUploadEnabled || admin || superuser"
      :to="{ name: 'Upload', params: { municipality: activeMunicipalitySlug } }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-file-arrow-up mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.uploadPortal") }}
      </span>
    </router-link>

    <!-- FACTSHEETS -->
    <div v-if="factsheetShow">
      <div class="d-flex align-items-center px-4 toggle-button">
        <i class="far fa-fw fa-chevron-down mr-3" />

        <span class="d-flex flex-wrap flex-shrink-1">
          {{ $t("navbarMenu.factsheets.title") }}
        </span>
      </div>

      <b-collapse
        class="factsheet-collapse"
        visible
      >
        <router-link
          v-if="isFactsheetEnabled || admin || superuser"
          :to="{
            name: 'Factsheet',
            params: { municipality: activeMunicipalitySlug },
          }"
          class="d-flex align-items-center px-4"
        >
          <i class="far fa-fw fa-chart-column mx-2" />
          <span class="d-flex flex-wrap flex-shrink-1">
            {{ $t("navbarMenu.factsheets.sheets.regularCharging") }}
          </span>
        </router-link>

        <router-link
          v-if="isParticipationEnabled || admin || superuser"
          :to="{
            name: 'Participation',
            params: { municipality: activeMunicipalitySlug },
          }"
          class="d-flex align-items-center px-4"
        >
          <i class="far fa-fw fa-users mx-2" />
          <span class="d-flex flex-wrap flex-shrink-1">
            {{ $t("navbarMenu.factsheets.sheets.participation") }}
          </span>
        </router-link>

        <router-link
          v-if="isBedrijventerreinenEnabled || admin || superuser"
          :to="{
            name: 'Bedrijventerreinen',
            params: { municipality: activeMunicipalitySlug },
          }"
          class="d-flex align-items-center px-4"
        >
          <i class="far fa-fw fa-truck-fast mx-2" />
          <span class="d-flex flex-wrap flex-shrink-1">
            {{ $t("navbarMenu.factsheets.sheets.businessParks") }}
          </span>
        </router-link>
      </b-collapse>
    </div>

    <!-- isExportEnabled ||  -->
    <router-link
      v-if="admin || superuser"
      :to="{
        name: 'FactsheetExport',
        params: { municipality: activeMunicipalitySlug },
      }"
      class="d-flex align-items-center px-4"
    >
      <i class="fas fa-fw fa-file-arrow-down mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.factsheets.export") }}
      </span>
    </router-link>

    <!-- EXPORT -->
    <!-- FACTSHEETS -->
    <div v-if="laadpalenExportShow">
      <div class="d-flex align-items-center px-4 toggle-button">
        <i class="far fa-fw fa-chevron-down mr-3" />

        <span class="d-flex flex-wrap flex-shrink-1">
          {{ $t("navbarMenu.chargingstations.export") }}
        </span>
      </div>

      <b-collapse
        class="factsheet-collapse"
        visible
      >
        <router-link
          v-if="admin || superuser"
          :to="{ name: 'Export', params: { municipality: activeMunicipalitySlug } }"
          class="d-flex align-items-center px-4"
        >
          <i class="far fa-fw fa-download mx-2" />
          <span class="d-flex flex-wrap flex-shrink-1">
            {{ $t("navbarMenu.chargingstations.municipality") }}
          </span>
        </router-link>

        <router-link
          v-if="superuser"
          :to="{ name: 'ExportNational' }"
          class="d-flex align-items-center px-4"
        >
          <i class="far fa-fw fa-truck-fast mx-2" />
          <span class="d-flex flex-wrap flex-shrink-1">
            {{ $t("navbarMenu.chargingstations.national") }}
          </span>
        </router-link>
      </b-collapse>
    </div>

    <!-- superusers only  -->
    <router-link
      v-if="superuser"
      :to="{ name: 'Import' }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-upload mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.chargingstations.import") }}
      </span>
    </router-link>

    <router-link
      :to="{ name: 'Manuals' }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-info-circle mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.manual") }}
      </span>
    </router-link>
    <router-link
      :to="{ name: 'ReleaseNotes' }"
      class="d-flex align-items-center px-4"
    >
      <i class="far fa-fw fa-rocket-launch mr-3" />
      <span class="d-flex flex-wrap flex-shrink-1">
        {{ $t("navbarMenu.release_notes") }}
      </span>
    </router-link>
  </div>
</template>

<script>
import { EventBus } from '@/services/eventbus'
import { codeToSlug } from '@/services/municipalities'
import { mapGetters } from 'vuex'

export default {
  name: 'NavBarMenu',
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters('config', [
      'isPrognoseEnabled',
      'isFactsheetEnabled',
      'isParticipationEnabled',
      'isBedrijventerreinenEnabled',
      'isPlanmodeEnabled',
      'isUploadEnabled',
      'isExportEnabled',
      'hasLayers',
    ]),
    ...mapGetters('access', ['getActiveMunicipality', 'hasAdminAccess']),

    factsheetShow() {
      return (
        this.isFactsheetEnabled ||
        this.isParticipationEnabled ||
        this.isBedrijventerreinenEnabled
      )
    },
    laadpalenExportShow() {
      return this.admin || this.superuser
    },

    superuser() {
      return this.$auth.user && this.$auth.user['https://evmaps.nl/superuser']
    },
    admin() {
      return this.hasAdminAccess({ code: this.getActiveMunicipality })
    },
    activeMunicipalitySlug() {
      return codeToSlug({ code: this.getActiveMunicipality })
    },
    canPreAccessPrognose() {
      return (
        this.hasLayers({ code: this.getActiveMunicipality }) &&
        (this.superuser || this.admin)
      )
    },
  },
  created() {
    EventBus.$on('overlay-click', this.maybeClose)
  },
  beforeDestroy() {
    EventBus.$off('overlay-click', this.maybeClose)
  },
  methods: {
    maybeClose() {
      if (this.busy) return

      EventBus.$emit('overlay-hide')
    },
    handleProcessing({ busy }) {
      this.busy = busy
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
  },
}
</script>

<style lang="scss">
.NavBarMenu {
  position: relative;
  background: white;
  z-index: 999999;
  opacity: 0.999;
  min-width: 450px;
  max-width: 450px;

  a,
  p,
  .toggle-button {
    font-size: 1.15rem;
    cursor: auto;
  }

  a,
  .toggle-button {
    margin-bottom: 1rem;
    color: var(--primary-text);

    &:hover {
      text-decoration: none;
      color: #b04300;
      cursor: pointer;
    }
  }

  .toggle-button {
    color: var(--primary-text) !important;
    cursor: default !important;
  }

  .factsheet-collapse {
    margin-left: 2rem;
  }

  &__logout {
    cursor: pointer !important;

    &:hover {
      color: #b04300;
    }
  }
}
</style>
